/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import classnames from 'classnames'
import style from './Button2.module.css'

export interface IButton2Props {
  isInline?: boolean
  isExternal?: boolean
  className?: string
  type?: 'submit' | 'reset' | 'button'
  link?: string
  dataQaLocator?: string
  isDisabled?: boolean
  tabIndex?: number
  outline?: boolean
  onClick?: React.MouseEventHandler<any>
  onMouseDown?: React.MouseEventHandler<any>
  onMouseUp?: React.MouseEventHandler<any>
  children?: React.ReactNode
}

export const Button2: React.FC<IButton2Props> = ({
  isInline,
  isExternal,
  className,
  link,
  isDisabled,
  outline,
  children,
  ...props
}) => {
  const finalClassName = classnames(style.button, { [style.inline]: isInline, [style.outline]: outline }, className)

  if (link) {
    const { onClick, onMouseDown, onMouseUp, ...anchorProps } = props as React.HTMLAttributes<HTMLAnchorElement>

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
      if (isDisabled) {
        e.preventDefault()

        return
      }
      onClick?.(e)
    }

    return (
      <a
        href={link}
        className={finalClassName}
        target={isExternal ? '_blank' : undefined}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        {...anchorProps}
        onClick={handleClick}
      >
        {children}
      </a>
    )
  }

  const { onClick, onMouseDown, onMouseUp, ...buttonProps } = props as React.ButtonHTMLAttributes<HTMLButtonElement>

  return (
    <button
      type="button"
      className={finalClassName}
      disabled={isDisabled}
      {...buttonProps}
      onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
      onMouseDown={onMouseDown as React.MouseEventHandler<HTMLButtonElement>}
      onMouseUp={onMouseUp as React.MouseEventHandler<HTMLButtonElement>}
    >
      {children}
    </button>
  )
}

Button2.displayName = 'Button2'
